import {ReactElement} from "react";
import IconMail from "../../data/Icons/leon-inmobiliaria-icons-e-mail.svg";
import IconPhone from "../../data/Icons/leon-inmobiliaria-icons-phone.svg";
import IconWhatsapp from "../../data/Icons/leon-inmobiliaria-icons-whatsapp.svg";
import Link from "next/link";
import {useTranslation} from "next-i18next";

interface ContactItemPropsInterface {
	text: string;
	icon: ReactElement;
	href: string;
}

function ContactItem(props: ContactItemPropsInterface) {
	return (
		<Link href={props.href}>
			<div className="flex justify-center md:justify-start grow md:hover:-translate-x-[calc(100%-4rem)] w-fit drop-shadow transition duration-300 bg-transparent md:bg-white md:hover:bg-leo-dark-brown rounded-tl-[10px] rounded-bl-[10px]">
				<div className="h-10 md:h-14 md:w-16 flex items-center justify-center">
					<div className="w-6 h-6 md:w-10 md:h-10">{props.icon}</div>
				</div>
				<div className="md:flex hidden items-center p-3 bg-white max-w-fit">
					<div>{props.text}</div>
				</div>
			</div>
		</Link>
	);
}

export default function ContactMenu() {
	const {t} = useTranslation();
	return (
		<div className="flex items-center justify-evenly bottom-0 z-10 h-fit w-screen md:w-fit md:right-0 md:flex-col md:gap-2 fixed md:top-[30%] md:-translate-y-2/4 md:items-start md:translate-x-[calc(100%-4rem)] bg-[#B9A997] md:bg-transparent">
			<ContactItem
				href="/ueber-uns#contact"
				text={t("components.contactMenu.mail")}
				icon={<IconMail className="text-white md:text-[#b8aa95]"/>}
			/>
			<div className="bg-white w-[2px] h-6 box md:hidden"/>
			<ContactItem
				href={`https://wa.me/${t("consts.contact.whatsapp")
					.replace("+", "")
					.replaceAll(" ", "")}`}
				text={t("components.contactMenu.wa")}
				icon={<IconWhatsapp className="text-white md:text-[#b8aa95]"/>}
			/>
			<div className="bg-white w-[2px] h-6 box md:hidden"/>
			<ContactItem
				href={`tel:${t("consts.contact.tel").replaceAll(" ", "")}`}
				text={t("consts.contact.tel")}
				icon={<IconPhone className="text-white md:text-[#b8aa95]"/>}
			/>
		</div>
	);
}
